import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { VCObserverWrapper } from '../vc';
import { interactions } from './common/constants';
import { remove } from './index';
var InteractionExtraMetrics = /*#__PURE__*/function () {
  function InteractionExtraMetrics() {
    _classCallCheck(this, InteractionExtraMetrics);
    // Store the finished interaction (as non-3p interaction)
    _defineProperty(this, "finishedInteraction", null);
    // independent VC observer, that observes until `custom.post-interaction-logs` event is sent
    _defineProperty(this, "vcObserver", null);
    _defineProperty(this, "sinkHandlerFn", function () {});
  }
  return _createClass(InteractionExtraMetrics, [{
    key: "initializeVCObserver",
    value: function initializeVCObserver(options) {
      this.vcObserver = new VCObserverWrapper(_objectSpread(_objectSpread({}, options), {}, {
        isPostInteraction: true
      }));
    }
  }, {
    key: "startVCObserver",
    value: function startVCObserver(_ref, interactionId) {
      var startTime = _ref.startTime;
      if (this.eligibleToMeasure(interactionId)) {
        var _this$vcObserver;
        (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
          startTime: startTime
        });
      }
    }
  }, {
    key: "stopVCObserver",
    value: function stopVCObserver() {
      var _this$vcObserver2;
      (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
    }

    // Check if the current interaction is eligible for measurement
  }, {
    key: "eligibleToMeasure",
    value: function eligibleToMeasure(interactionId) {
      var interaction = interactions.get(interactionId);
      return (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'page_load' || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'transition';
    }
  }, {
    key: "updateFinishedInteraction",
    value: function updateFinishedInteraction(interaction) {
      if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'page_load' || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'transition') {
        this.finishedInteraction = interaction;
      }
    }
  }, {
    key: "setLastInteractionFinishVCResult",
    value: function setLastInteractionFinishVCResult(result) {
      this.lastInteractionFinishVCResult = result;
    }
  }, {
    key: "sinkHandler",
    value: function sinkHandler(fn) {
      this.sinkHandlerFn = fn;
    }
  }, {
    key: "onInteractionComplete",
    value: function onInteractionComplete(id, data) {
      if (data.ufoName) {
        var _this$vcObserver3;
        var updatedData = _objectSpread(_objectSpread({}, data), {}, {
          vcObserver: (_this$vcObserver3 = this.vcObserver) !== null && _this$vcObserver3 !== void 0 ? _this$vcObserver3 : undefined
        });
        this.sinkHandlerFn(id, updatedData, this.finishedInteraction, this.lastInteractionFinishVCResult);
      }
      this.stopVCObserver();
      remove(id);
      this.reset();
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this$finishedInterac;
      this.stopVCObserver();
      if ((_this$finishedInterac = this.finishedInteraction) !== null && _this$finishedInterac !== void 0 && _this$finishedInterac.id) {
        remove(this.finishedInteraction.id);
      }
      this.finishedInteraction = null;
      this.lastInteractionFinishVCResult = undefined;
    }
  }, {
    key: "stopAll",
    value: function stopAll(id) {
      remove(id);
      this.reset();
    }
  }]);
}();
export { InteractionExtraMetrics as default };